import Helpers from '../../javascripts/lib/helpers';
import MemberSearchMap from '../../javascripts/application/member-search-map';

Helpers.ready(() => {
  window.memberSearchMap = new MemberSearchMap('[data-js-map]');
})
